<template>
	<li>
		<article class="flex gap-4 rounded-lg bg-white p-4 shadow-sm ring-1 ring-gray-200 sm:p-5">
			<!-- Remetente !-->
			<SupportTicketAvatar :label="authorLabel" :variant="isOperator ? 'team' : 'requester'" size="lg"/>
			<div class="min-w-0 flex-1">
				<!-- Cabeçalho: quem escreveu, quando, e espaço para ações !-->
				<header class="flex items-center gap-2 border-b border-gray-100 pb-2">
					<span class="truncate text-sm font-semibold text-gray-900">{{ authorLabel }}</span>
					<span v-if="isYou" class="flex-none text-xs text-gray-400">você</span>
					<div class="ml-auto flex flex-none items-center gap-3">
						<slot name="actions"/>
						<time :datetime="message.created_at" class="whitespace-nowrap text-xs tabular-nums text-gray-500">
							{{ $displayDateTime(message.created_at) }}
						</time>
					</div>
				</header>
				<!-- Corpo !-->
				<div class="pt-3">
					<VueShowdown :markdown="message.body" class="prose prose-sm max-w-none leading-relaxed text-gray-700"/>
				</div>
				<!-- Anexos !-->
				<ul v-if="attachments.length" class="mt-3 flex flex-wrap gap-2 border-t border-gray-100 pt-3">
					<li v-for="attachment in attachments" :key="attachment.id">
						<a
							:href="attachment.url"
							target="_blank"
							rel="noopener"
							:title="attachment.file_name"
							class="inline-flex max-w-xs items-center gap-2 rounded-md bg-gray-50 px-3 py-1.5 text-xs text-gray-700 ring-1 ring-gray-200 hover:bg-gray-100 hover:text-turquoise">
							<i class="fa fa-paperclip flex-none text-gray-400"></i>
							<span class="truncate">{{ attachment.file_name }}</span>
							<span v-if="attachment.size_formatted" class="flex-none text-gray-400">{{ attachment.size_formatted }}</span>
						</a>
					</li>
				</ul>
			</div>
		</article>
	</li>
</template>

<script>
import {VueShowdown} from "vue-showdown"

import SupportTicketAvatar from "./SupportTicketAvatar.vue"

export default {
	name: "SupportTicketMessage",
	components: {SupportTicketAvatar, VueShowdown},
	props: {
		message: {
			type: Object,
			required: true
		},
		/**
		 * Id de quem abriu o chamado: separa cliente de operador
		 */
		requesterId: [Number, String]
	},
	computed: {
		attachments() {
			return this.$data_get(this.message, "attachments", []) ?? []
		},
		authorLabel() {
			return this.$data_get(this.message, "created_by.label", "—")
		},
		authorId() {
			return this.$data_get(this.message, "created_by.id")
		},
		isOperator() {
			return !!this.requesterId && this.authorId != this.requesterId
		},
		isYou() {
			const profileId = this.$data_get(this.$profile, "id")
			return !!profileId && this.authorId == profileId
		}
	}
}
</script>
